var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.hasAutoprovisioningPermission
    ? _c(
        "div",
        [
          _c("h3", [_vm._v("Autoprovisioning Configuration")]),
          _vm._v(" "),
          _c("hr"),
          _vm._v(" "),
          _vm.loading
            ? _c("div", { staticClass: "alert alert-info" }, [
                _c("p", [_vm._v("Loading autoprovisioning configuration...")])
              ])
            : _vm.showForm
            ? _c(
                "div",
                [
                  _c("AutoprovisioningForm", {
                    attrs: {
                      "domain-uuid": _vm.domainUuid,
                      "domain-name": _vm.domainName,
                      config: _vm.formMode === "edit" ? _vm.config : null
                    },
                    on: {
                      configCreated: _vm.handleConfigCreated,
                      configUpdated: _vm.handleConfigUpdated,
                      cancel: function($event) {
                        _vm.showForm = false
                      }
                    }
                  })
                ],
                1
              )
            : _vm.config
            ? _c("div", [
                _c("div", { staticClass: "well" }, [
                  _c("div", { staticClass: "row" }, [
                    _c(
                      "div",
                      { staticClass: "col-sm-12" },
                      [
                        _c("h4", [_vm._v("Current Configuration")]),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-group" }, [
                          _c("p", { staticClass: "control-label" }, [
                            _vm._v("Roster Service")
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v(
                              _vm._s(_vm.formatRosterService(_vm.rosterService))
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "form-group" },
                          [
                            _c(
                              "p",
                              {
                                staticClass: "control-label",
                                attrs: {
                                  role: "button",
                                  "aria-label": _vm.showConfigDetails
                                    ? "Hide configuration details"
                                    : "Show configuration details",
                                  "aria-expanded": _vm.showConfigDetails
                                },
                                on: { click: _vm.toggleConfigDetails }
                              },
                              [
                                _c("i", {
                                  staticClass: "fa",
                                  class: _vm.showConfigDetails
                                    ? "fa-caret-down"
                                    : "fa-caret-right"
                                }),
                                _vm._v(
                                  "\n                  Configuration\n                "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm.showConfigDetails
                              ? _c("AutoprovisioningConfigDisplay", {
                                  attrs: { config: _vm.config }
                                })
                              : _vm._e()
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-group" }, [
                          _c("p", { staticClass: "control-label" }, [
                            _vm._v("Import Options")
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v("Auto-commit import: "),
                            _c("strong", [
                              _vm._v(
                                _vm._s(
                                  _vm.boolPropDisplay(_vm.autoCommitImport)
                                )
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v("Auto-deactivate users: "),
                            _c("strong", [
                              _vm._v(
                                _vm._s(
                                  _vm.boolPropDisplay(_vm.autoDeactivateUsers)
                                )
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v("Auto-update titles: "),
                            _c("strong", [
                              _vm._v(
                                _vm._s(
                                  _vm.boolPropDisplay(_vm.autoupdateTitles)
                                )
                              )
                            ])
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _vm._v("Two Kit Import: "),
                            _c("strong", [
                              _vm._v(_vm._s(_vm.boolPropDisplay(_vm.twoKit)))
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-group" }, [
                          _c("p", { staticClass: "control-label" }, [
                            _vm._v("CSV S3 Output Directory")
                          ]),
                          _vm._v(" "),
                          _c("p", [
                            _c("code", [_vm._v(_vm._s(_vm.csvUploadS3Prefix))])
                          ])
                        ]),
                        _vm._v(" "),
                        _vm.config.updated_at
                          ? _c("div", { staticClass: "form-group" }, [
                              _c("p", { staticClass: "control-label" }, [
                                _vm._v("Last Updated")
                              ]),
                              _vm._v(" "),
                              _c("p", [
                                _vm._v(
                                  _vm._s(
                                    new Date(
                                      _vm.config.updated_at
                                    ).toLocaleString()
                                  )
                                )
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-group" }, [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-success",
                              on: { click: _vm.showImportOptions }
                            },
                            [
                              _c("i", { staticClass: "fa fa-play" }),
                              _vm._v(" On-demand import\n                ")
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-primary",
                              on: { click: _vm.editConfig }
                            },
                            [_vm._v("Edit Configuration")]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-danger",
                              on: { click: _vm.confirmDelete }
                            },
                            [_vm._v("Delete Configuration")]
                          )
                        ]),
                        _vm._v(" "),
                        _vm.config
                          ? _c("AutoprovisioningSchedule", {
                              attrs: {
                                "domain-uuid": _vm.domainUuid,
                                "domain-name": _vm.domainName
                              }
                            })
                          : _vm._e()
                      ],
                      1
                    )
                  ])
                ])
              ])
            : _c("div", [
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary",
                    on: { click: _vm.setupConfig }
                  },
                  [_vm._v("Set up Autoprovisioning")]
                )
              ]),
          _vm._v(" "),
          _c(
            "modal",
            {
              attrs: { value: _vm.showDeleteModal, title: "Confirm Delete" },
              on: {
                hide: function($event) {
                  _vm.showDeleteModal = false
                },
                input: function($event) {
                  _vm.showDeleteModal = $event
                }
              }
            },
            [
              _c("p", [
                _vm._v(
                  "Are you sure you want to delete this autoprovisioning configuration?"
                )
              ]),
              _vm._v(" "),
              _c("div", { attrs: { slot: "footer" }, slot: "footer" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-default",
                    attrs: { type: "button" },
                    on: {
                      click: function($event) {
                        _vm.showDeleteModal = false
                      }
                    }
                  },
                  [_vm._v("Cancel")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "btn btn-danger",
                    attrs: { type: "button" },
                    on: { click: _vm.deleteConfig }
                  },
                  [_vm._v("Delete")]
                )
              ])
            ]
          ),
          _vm._v(" "),
          _vm.config
            ? _c("import-modal", {
                attrs: {
                  "external-open": _vm.showImportModal,
                  "domain-uuid": _vm.domainUuid,
                  config: _vm.config
                },
                on: {
                  "update:externalOpen": function($event) {
                    _vm.showImportModal = $event
                  },
                  "update:external-open": function($event) {
                    _vm.showImportModal = $event
                  },
                  success: _vm.handleImportSuccess,
                  error: _vm.handleImportError,
                  cancel: function($event) {
                    _vm.showImportModal = false
                  }
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("hr")
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "alert alert-info" }, [
      _c("p", [
        _vm._v(
          "No automated user provisioning configuration exists for this domain."
        )
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }